import { createReducer, on } from '@ngrx/store';
import { format } from 'date-fns';
import { EditCampaignSuccess } from '../actions/campaign-search.actions';
import { CampaignSelectionTargetChanged } from '../actions/wizard-setup.actions';
import {
  CampaignCategoriesSuccess,
  CampaignCategoryChanged,
  CampaignNameChanged,
  currentStep,
  goToStep,
  nextStep,
  previousStep,
  ResetWizard,
  SaveCampaignSuccess,
  WizardCampaignSelectionTargetChanged,
} from '../actions/wizard.actions';
import { WIZARD_STEPS_ORDER, WizardState } from '../models/wizard.model';

const initialState: WizardState = {
  currentStepIndex: 0,
  campaignSelectionTarget: '',
  disableNextButton: false,
  campaignName: `New Campaign_ ${format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSSxx")}`,
  campaign: null,
  isUpdate: false,
  campaignCategories: [],
  campaignCategoryId: null,
  campaignId: null,
};

export const WizardReducer = createReducer(
  initialState,
  on(EditCampaignSuccess, (state, { campaign }) => ({
    ...state,
    campaign,
    campaignSelectionTarget: campaign.data.campaignSelectionTarget,
    campaignName: campaign.data.campaignName,
    campaignCategoryId: campaign.data.campaignCategoryId,
    campaignId: campaign.campaignId,
    isUpdate: true,
    disableNextButton: false,
  })),
  on(SaveCampaignSuccess, (state, { res }) => ({
    ...state,
    campaignId: res.campaignId,
    isUpdate: true,
    campaign: {
      ...state.campaign,
      campaignId: res.campaignId,
    },
  })),
  on(currentStep, (state, { currentStepIndex }) => ({
    ...state,
    currentStepIndex,
    disableNextButton: currentStepIndex === 0 && !state.campaignSelectionTarget ? true : false,
  })),
  on(nextStep, (state) => {
    const nextIndex = state.currentStepIndex + 1;
    if (nextIndex >= WIZARD_STEPS_ORDER.length) {
      return state;
    }
    return { ...state, currentStepIndex: nextIndex };
  }),
  on(previousStep, (state) => {
    const prevIndex = state.currentStepIndex - 1;
    if (prevIndex < 0) {
      return state;
    }
    return { ...state, currentStepIndex: prevIndex };
  }),
  on(goToStep, (state, { index }) => ({
    ...state,
    currentStepIndex: index,
  })),
  on(CampaignSelectionTargetChanged, (state, { campaignSelectionTarget }) => ({
    ...state,
    campaignSelectionTarget,
    disableNextButton: state.currentStepIndex === 0 && !campaignSelectionTarget ? true : false,
  })),
  on(WizardCampaignSelectionTargetChanged, (state, { campaignSelectionTarget }) => ({
    ...state,
    campaignSelectionTarget,
  })),
  on(CampaignCategoriesSuccess, (state, { campaignCategories }) => ({
    ...state,
    campaignCategories,
  })),
  on(CampaignCategoryChanged, (state, { campaignCategoryId }) => ({
    ...state,
    campaignCategoryId,
  })),
  on(CampaignNameChanged, (state, { campaignName }) => ({
    ...state,
    campaignName,
  })),
  on(ResetWizard, (state) => ({
    ...initialState,
    campaignCategories: state.campaignCategories,
  })),
);
